import { ref, computed } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useSnackbarStore } from '@/stores/snackbar'
import api from '@/utils/api'

export function useExpiryWarning() {
  const authStore = useAuthStore()
  const snackbar = useSnackbarStore()
  
  const expiryWarning = ref(null)
  const showWarning = computed(() => !!expiryWarning.value)
  
  // API interceptor арқылы expiry warning тексеру
  const setupExpiryInterceptor = () => {
    api.interceptors.response.use(
      (response) => {
        // X-Expiry-Warning header тексеру
        const warningHeader = response.headers['x-expiry-warning']
        if (warningHeader) {
          try {
            const warningData = JSON.parse(decodeURIComponent(warningHeader))
            expiryWarning.value = warningData
            
            // Snackbar арқылы ескертпе көрсету
            snackbar.warning(
              `⚠️ ${warningData.message}. Админмен хабарласыңыз.`,
              { 
                timeout: 10000,
                persistent: true
              }
            )
          } catch (error) {
            // Console log removed
          }
        }
        return response
      },
      (error) => {
        // 403 expired check
        if (error.response?.status === 403 && error.response?.data?.expired) {
          snackbar.error(error.response.data.error, { persistent: true })
          // Force logout
          authStore.logout()
        }
        return Promise.reject(error)
      }
    )
  }
  
  const dismissWarning = () => {
    expiryWarning.value = null
  }
  
  const formatExpiryDate = (dateString) => {
    if (!dateString) return ''
    const date = new Date(dateString)
    return date.toLocaleDateString('kz-KZ', {
      year: 'numeric',
      month: 'long', 
      day: 'numeric'
    })
  }
  
  return {
    expiryWarning,
    showWarning,
    setupExpiryInterceptor,
    dismissWarning,
    formatExpiryDate
  }
}